import { required, minValue, requiredUnless, requiredIf } from 'vuelidate/lib/validators';

export default {
    validations: {
        invoice: {
            billingAddress: {
                requireEori: {},
                name: {required},
                street1: {required},
                city: {required},
                countryCode: {required},

                euriNumber: {
                    required: requiredIf((vm) => {
                        if (vm.isPrivate)
                            return false
                        if (vm.requireEori)
                            return true;
                        if (vm.countryCode === 'GB') {
                            return true;
                        }
                        return false;
                    })
                },
            },
            senderAddress: {
                requireEori: {},
                name: {required},
                street1: {required},
                city: {required},
                countryCode: {required},

                euriNumber: {
                    required: requiredIf((vm) => {
                        if (vm.isPrivate)
                            return false
                        if (vm.requireEori)
                            return true;
                        if (vm.countryCode === 'GB') {
                            return true;
                        }
                        return false;
                    })
                },
            },
            deliverAddress: {
                requireEori: {},
                name: {required},
                street1: {required},
                city: {required},
                countryCode: {required},

                euriNumber: {
                    required: requiredIf((vm) => {
                        if (vm.isPrivate)
                            return false
                        if (vm.requireEori)
                            return true;
                        if (vm.countryCode === 'GB') {
                            return true;
                        }
                        return false;
                    })
                },
            },
            invoiceDetails: {
                invoiceNumber: {required},
                invoiceDate: {required},
                incoterm: {required},
                exportReason: {required},
                valuta: {required},
                invoiceType: {required},
                totalWeight: {minValue: minValue(0), required},
                transportProduct: {required}
            },
            invoiceLines: {
                $each: {
                    requireHsCode: {},
                    harmonizedCode: {
                        required: requiredIf((vm) => {
                            return vm.requireHsCode;
                        })
                    },
                    commodity: {required},
                    countryOfOrigin: {required},
                    quantity: {minValue: minValue(0.1), required},
                    unitType: {required},
                    unitPrice: {minValue: minValue(0.1), required},
                    manufacturer: {}
                }
            },
            freightCosts: {
                minValue: minValue(0), required
            },
            insuranceCosts: {minValue: minValue(0), required},
            otherCosts: {minValue: minValue(0), required},
            customCosts: {minValue: minValue(0), required},
        }
    }
};
